module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_case3-a0b9d743217e212f456241f8dfb58cc7.jpg";